<template>
  <el-form-item label="运输公司" size="small">
    <el-select clearable v-model="searchForm.shop_id" filterable placeholder="请选择运输公司" @change="setShopId">
      <el-option v-for="item in shopCompanyData" :label="item.name" :value="item.id" :key="item.id"></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import moment from 'moment'     //日期时间转换

export default {
  name: "shopCompanyTemp",
  data() {
    return {
      shopCompanyData:[], //车辆列表
      searchForm: {
        shop_id:''
      }
    };
  },
  created() {
    this.getShopCompanyData()
  },
  methods: {
    setShopId(value){
      this.$emit('changeData',value)
    },
    getShopCompanyData() {
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.shopGetShopList(param).then(res=>{
        if(res.code == 200){
          //console.log(res.data.data);
          this.shopCompanyData = res.data.data
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    }

  },
};
</script>


// WEBPACK FOOTER //
// src/view/common/shopCompanyTemp.vue